<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="fuzzySearch" :label="$lang.fuzzySearch" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.disabled" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="disabled" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.readonly" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="readonly" /><!--
          --><checkbox label-size="xs" v-model="iconLeft" :label="$lang.iconLeft" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="iconRight" :label="$lang.iconRight" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="clearable" :label="$lang.clearable" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="12" v-for="(item, index) in autocompletes" :key="index">
        <card :overflow-off="false">
          <card-text>
            <autocomplete
              @input="onInput"
              @clear="onClear"
              @show="onShow"
              @hide="onHide"
              v-model="item.model"
              :disabled="disabled"
              :fuzzy-search="fuzzySearch"
              :readonly="readonly"
              :clearable="clearable"
              :label="$lang[item.label]"
              :placeholder="$lang.startTyping"
              :color="$root.$colors.primary"
              :color-lightness="$root.$colors.bgColorLightness"
              :items="item.items"
              :sort="item.sort"
              :icon-left="iconLeft ? item.iconLeft : null"
              :icon-right="iconRight ? 'information' : null" />
          </card-text>
          <divider />
          <card-actions align="center">
            <code-chunk :pre="false">v-model: {{ item.model }}</code-chunk>
          </card-actions>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageAutocomplete',
  mixins: [
    methods
  ],
  data () {
    return {
      autocompletes: [{
        model: '',
        sort: true,
        iconLeft: 'language-javascript',
        items: [...new Set(this.$router.options.routes.map(route => {
          return route.title
        }))],
        label: 'pickABcqComponent'
      }, {
        model: '',
        sort: false,
        iconLeft: 'calendar',
        items: Array.from({length: 12}, (item, i) => {
          return new Date(0, i).toLocaleString('en-US', {month: 'long'})
        }),
        label: 'pickAMonth'
      }],
      iconLeft: true,
      iconRight: true,
      disabled: false,
      clearable: true,
      readonly: false,
      fuzzySearch: false
    }
  },
  methods: {
    onInput ($event) {
      this.log('input', 'autocomplete', $event)
    },
    onClear ($event) {
      this.log('clear', 'autocomplete', $event)
    },
    onShow ($event) {
      this.log('show', 'autocomplete', $event)
    },
    onHide ($event) {
      this.log('hide', 'autocomplete', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/forms/autocomplete.vue